export const version = '1.0.0';
export const navbarBreakPoint = 'xl';

export let APIURL = process.env.REACT_APP_API_URL;